var map = {
	"./assets/flags/amex.png": "7145",
	"./assets/flags/aura.png": "2bd8",
	"./assets/flags/diners.png": "ec80",
	"./assets/flags/discover.png": "697a",
	"./assets/flags/elo.png": "4aad",
	"./assets/flags/hiper.png": "4d7b",
	"./assets/flags/hipercard.png": "4bc7",
	"./assets/flags/jcb.png": "1949",
	"./assets/flags/master.png": "c6a1",
	"./assets/flags/placeholder.png": "c9af",
	"./assets/flags/sorocred.svg": "0125",
	"./assets/flags/visa.png": "15b2",
	"./assets/icons/add.svg": "76a4",
	"./assets/icons/alert.svg": "659f",
	"./assets/icons/arrow-down.svg": "c874",
	"./assets/icons/arrow-left.svg": "ac3b",
	"./assets/icons/arrow-to-bottom.svg": "85fb",
	"./assets/icons/arrow.svg": "21e2",
	"./assets/icons/back-arrow.svg": "85f2",
	"./assets/icons/bag-shopping-2.svg": "2dcb",
	"./assets/icons/calendar.svg": "b8bd",
	"./assets/icons/card-off.svg": "90e3a",
	"./assets/icons/card.svg": "5d4a",
	"./assets/icons/check-off.svg": "5b15",
	"./assets/icons/check-on.svg": "6585",
	"./assets/icons/check-success.svg": "f955",
	"./assets/icons/checkbox.svg": "5b02",
	"./assets/icons/close.svg": "8b1b",
	"./assets/icons/credit-card-blank.svg": "f53e",
	"./assets/icons/credit-cards-up.svg": "97b5",
	"./assets/icons/cry-girl-animated.svg": "5d1e",
	"./assets/icons/documents-off.svg": "dd1c",
	"./assets/icons/documents.svg": "70cd",
	"./assets/icons/dollar-atm.svg": "c4e6",
	"./assets/icons/edit.svg": "daf0",
	"./assets/icons/flag-nav.svg": "325f",
	"./assets/icons/food.svg": "3f35",
	"./assets/icons/health.svg": "d4c8",
	"./assets/icons/heart.svg": "7d16",
	"./assets/icons/home-off.svg": "5d67",
	"./assets/icons/home.svg": "ac9d",
	"./assets/icons/icon-chevron.png": "d719",
	"./assets/icons/icone-onetouch-paypal.svg": "c892",
	"./assets/icons/icone-paypal.svg": "45b0",
	"./assets/icons/icone-seguranca-paypal.svg": "1fa8",
	"./assets/icons/icone-tooltip.svg": "9fc0",
	"./assets/icons/icons-laboratory.svg": "b851",
	"./assets/icons/icons-medic.svg": "8a8f",
	"./assets/icons/icons-medication.svg": "81e5",
	"./assets/icons/icons-video-consultation.svg": "d6dd",
	"./assets/icons/laptop.svg": "cd06",
	"./assets/icons/livelo.svg": "ac52",
	"./assets/icons/location.svg": "d2eb",
	"./assets/icons/logo-bb.svg": "2d15",
	"./assets/icons/logo-googlePay.svg": "ded8",
	"./assets/icons/logo-paypal-branco.svg": "9634",
	"./assets/icons/logo-paypal.svg": "237c",
	"./assets/icons/notebook.svg": "6ca5",
	"./assets/icons/onetouch-mercado-pago.svg": "24ad",
	"./assets/icons/pet.svg": "ea5a",
	"./assets/icons/products/devices/icon-time.svg": "a916",
	"./assets/icons/promocode.svg": "fe2e",
	"./assets/icons/protection-covid.svg": "3183",
	"./assets/icons/protection.svg": "3689",
	"./assets/icons/seguranca-mercado-pago.svg": "dbf7",
	"./assets/icons/shield-cash-protection.svg": "463d",
	"./assets/icons/sim-card.svg": "a6f5",
	"./assets/icons/smartphone.svg": "4008",
	"./assets/icons/smartwatch.svg": "258d",
	"./assets/icons/solidarity.svg": "670d",
	"./assets/icons/success-big.svg": "493c",
	"./assets/icons/success-with-circle.svg": "703d",
	"./assets/icons/success.svg": "1c27",
	"./assets/icons/tablet.svg": "a9e0",
	"./assets/icons/telemedicine.svg": "bf08",
	"./assets/icons/time.svg": "79aa",
	"./assets/icons/tools.svg": "a035",
	"./assets/icons/tourism.svg": "4b80",
	"./assets/icons/user.svg": "6aed",
	"./assets/icons/voltar-arrow.svg": "bd6a",
	"./assets/icons/warning--blue.svg": "b863",
	"./assets/icons/warning.svg": "daa9",
	"./assets/paguemenos.png": "61fa",
	"./assets/style/_app.scss": "08eb",
	"./assets/style/_card.scss": "6f6b",
	"./assets/style/_reset.scss": "f37e",
	"./assets/style/_variables.scss": "6b4c",
	"./assets/style/index.scss": "44fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";